<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="form" inline>
					<c-form-item type="input" label="收支流水号" name="record_number"></c-form-item>
					<c-form-item type="select" label="收付渠道" name="record_channel" :options="recordChannel"></c-form-item>
					<c-form-item type="select" label="收支类型" name="record_type" :options="recordType"></c-form-item>
					<c-form-item type="select" label="收付类型" name="turnover_type" :options="turnoverType"></c-form-item>
          <c-form-item type="select" label="业务场景" name="business_type" :options="businessType"></c-form-item>
          <c-form-item type="input" label="业务单号" name="business_number"></c-form-item>
          <c-form-item type="input" label="收付关联号" name="turnover_number"></c-form-item>
          <c-form-item type="select" label="费用类型" name="account_title" :options="feeNameOptions"></c-form-item>
          <c-form-item type="input" label="摘要" name="remark"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button @click="exportData()">导出</c-button>
			</m-operate>
			
			<c-table ref="table">				

				<c-table-column
					label="账户名称"
					name="account_name"
					width="110"
				>
					<template v-slot="{data}">
						{{account_name}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="收支流水号"
					name="record_number"
					width="150"
				>
				</c-table-column>
				
				<c-table-column
					label="收付渠道"
					name="record_channel"
					width="80"
				>
				</c-table-column>

        <c-table-column
					label="收支类型"
					name="record_type"
          width="80"
				>
            <template v-slot="{data}">
                <span v-if="data.record_type == '收款'" style="color:green">收款</span>
                <span v-else-if="data.record_type == '付款'" style="color:red">付款</span>
                <span v-else>--</span>
            </template>
        </c-table-column>

				<c-table-column
					label="业务类型"
					name="turnover_type"
          width="80"
				>
				</c-table-column>
				
				<c-table-column
					label="业务场景"
					name="business_type_zh"
          width="80"
				>
				</c-table-column>

				<c-table-column
					label="业务单号"
					name="business_number"
					width="130"
				>
				</c-table-column>

				<c-table-column
					label="收付关联号"
					name="turnover_number"
					width="140"
				>
				</c-table-column>

				<c-table-column
					label="费用类型"
					name="account_title"
					width="130"
				>
				</c-table-column>

				<c-table-column
					label="发生金额"
					name="money"
					width="100"
				>
					<template v-slot="{data}">
						￥{{data.money}}
					</template>
				</c-table-column>

				<c-table-column
					label="账户余额"
					name="surplus_money"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.surplus_money}}
					</template>
				</c-table-column>

				<c-table-column
					label="待结算金额"
					name="settle_amount"
					width="100"
				>
					<template v-slot="{data}">
						￥{{data.settle_amount}}
					</template>
				</c-table-column>

				<c-table-column
					label="摘要"
					name="remark"
          width="200"
        >
				</c-table-column>

				<c-table-column
					label="发生时间"
					name="create_date"
					width="150"
				>
				</c-table-column>

			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";

    export default {
		name: 'm_finance_sys_account_record',
        computed: {
            ...mapState(['systemConfig']),
            feeNameOptions() {
              return (
                  [
                    {name: '商品货款',value:'商品货款'},
                    {name: '物流费',value:'物流费'},
                    {name: '商家服务费',value:'商家服务费'},
                    {name: '平台补贴',value:'平台补贴'},
                  ].concat(this.systemConfig.share_enable == 'ON'?[
                    {name: '代理卡收益',value: '代理卡收益'},
                    {name: '分销奖励',value: '分销奖励'}
                  ]:[])
                      .concat([
                        {name:"分享赚奖励",value:"分享赚奖励"},
                        {name:"售后差额",value:"售后差额"},
                        {name:"商品代发费",value:"商品代发费"},
                        {name:"技术服务费",value:"技术服务费"},
                        {name:"平台服务费",value:"平台服务费"}
                      ])
              );
            }
        },

		data() {
			return {
				recordChannel: [{
					name: '请选择',
					value: ''
				},{
					name: '余额',
					value: '余额'
				}, {
					name: '保证金',
					value: '保证金'
				}, {
					name: '待结算',
					value: '待结算'
				}],

				recordType: [
					{
						name: '请选择',
						value: ''
					},{
						name: '收款',
						value: '收款'
					},{
						name: '付款',
						value: '付款'
					}
				],

				turnoverType: [
					{
						name: '请选择',
						value: ''
					},{
						name: '待结算',
						value: '待结算'
					},{
                        name: '取消结算',
                        value: '取消结算'
                    },{
						name: '结算',
						value: '结算'
					},{
						name: '退款',
						value: '退款'
					},{
						name: '提现',
						value: '提现'
					}
				],

				businessType: [],
				disabled: true
			}
		},

		props: {
			id: String,
			account_name: String
		},

		mounted() {
			this.getBusinessType();
			this.$refs.search.search();
		},

        watch: {
            id(){
                this.$refs.search.search();
            }
        },

		methods: {
			searchHandle(data) {
				data.account_id = this.id;
				this.$refs.table.load({
					url: '/sys/account/record/list',
					data
				});
			},
			getBusinessType(){
				this.request({
					url: '/sys/account/record/business_type',
					success: data => {
						this.businessType = data;
					}
				});
			},
			exportData(){
				var exportData = this.$refs.form.serialize();
				exportData.job_id = 28;
				exportData.create_system = 'OMS';
				exportData.account_id = this.id;

				this.request({
					url: '/export_job/add',
					data: exportData,
					success: data => {
						this.$message({
		                  	text: '导出任务创建成功，请前往任务中心查看导出进度',
		                  	icon: 'success'
		                });
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>